export default {
	showRejectExhibition: false,
	showDeletePayment: false,
}
